<template>
    <div class="rcornersgrey mx-auto vstack" style="max-width:800px; overflow: initial;">
        <h1 class="text-center">{{title}}</h1>
        <div class="container">                 
            <label class="required" for="txtNewPassword">
                Password
            </label>
            <input type="password" id="txtNewPassword" class="form-control mb-2" required v-model="newPassword"/>
            <label class="required" for="txtConfirmNewPassword">
                Confirm Password
            </label>
            <input type="password" id="txtConfirmNewPassword" class="form-control" required v-model="confirmPassword"/>
            <div id="buttonWrap" class="mt-4">
                <button class="btn btn-lg btn-primary" type="button" aria-label="submit button" @click.prevent="handleSubmitClick">Submit</button>
            </div>
            <div :class="{'alert-danger':alertType == 'error', 'alert-success':alertType == 'success'}" class="alert mt-1" role="alert" v-show="showAlert">
                {{ alertText }}
            </div>
            <a href="signin.aspx" v-if="resetComplete">Return to sign in page</a>
        </div>
    </div>
</template>
<script setup lang="ts">
import { useUserStore } from '@/stores/userStore';
import { info } from 'sass';
import { computed, ref, watch, PropType } from 'vue';

const props = defineProps<{
    title:string,
    resetCode:string,
    user:string
}>()

const newPassword = ref("");
const confirmPassword = ref("");
const showAlert = ref(false);
const alertText = ref("");
const alertType = ref("error");
const emits = defineEmits(['submit']);
const userStore = useUserStore();
const resetComplete = ref(false);

userStore.validateResetCode(props.user, props.resetCode)?.then((result)=> {
    
    if(typeof(result) === "boolean" && result == false ){
        SetAlertInfo("error", "The link that was used to access this page has expired. Please try resetting your password again.");
    }
 });

function handleSubmitClick() {
    validateInputs(()=> {
        
        if(!showAlert.value){
            userStore.postPasswordChangeInformation(props.user, newPassword.value, props.resetCode)?.then((result)=> {
console.log("Post Change Info Result :",result);
                if(result && result.data == true ){
                    SetAlertInfo("success", "Password change complete");
                    resetComplete.value = true;
                }
                else {
                    SetAlertInfo("error", "An error was encountered while trying to change your password. Please try again or contact your administrator.");
                    resetComplete.value = false;
                }
            
            });
        }
    });
}

function validateInputs(callback: () => void) {    
        if(newPassword.value != confirmPassword.value){
            alertText.value = "New password and confirm password values must match!";
            showAlert.value = true;
            callback();
        }
        else {
            userStore.validateNewPassword(props.user, newPassword.value).then((data: string[]) => {                
                showAlert.value = true;                
                
                if(data != undefined && data.length > 0){
                    let validationMessages = "";

                    if(data.length === 1){
                        validationMessages = data[0];
                    }
                    else{
                        data.forEach(message => {
                            if(message){
                                validationMessages += `- ${message}`;
                            }
                        });
                    }
                    
                    alertText.value = validationMessages;
                    showAlert.value = true;
                }
                else {
                    showAlert.value = false;
                }

                callback();
            });
        }    
}

function SetAlertInfo(type:string, text: string){
    alertType.value = type;
    alertText.value = text;
    showAlert.value = true;
}
</script>